import Vue from 'vue'
import Vuex from 'vuex'
import globalStore from 'global/store'
import contracts from './modules/contracts'
import support from './modules/support'
import calls from './modules/calls'
import callFiles from './modules/calls-files'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        ...globalStore,
        calls,
        callFiles,
        contracts,
        support
    },
})